<template lang="pug">
div
  v-btn(small, text, color="secondary", @click="open()") Void Charge
  v-dialog(v-model="dialog", width="500")
    v-card
      v-card-title Void Charge
      v-form(@submit.prevent="load()")
        v-card-text
          v-text-field(v-model.number="amount", label="Amount (cent)")
          v-text-field(v-model="retref", label="Retref")
          div(v-if="result")
            .subtitle-2 Result
            pre {{ result }}
        v-card-actions
          v-btn(color="primary", type="submit", :loading="loading") Submit
</template>

<script>
export default {
  props: {
    mid: { type: String, required: true },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      amount: 500,
      retref: "",
      result: null,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    async load() {
      if (!this.mid) return;
      this.loading = true;
      const params = {
        mid: this.mid,
        amount: String(this.amount),
        retref: this.retref,
      };
      try {
        this.result = await this.$api.cardpointe.cardconnect.voidCharge(params);
      } catch (e) {
        this.$toast.error(e.response?.data || e.message);
      }
      this.loading = false;
    },
  },
};
</script>